module.exports = __webpack_public_path__ + "img/107141922.85cf5ef7.jpg";